import React from 'react';
// model
import VacancyInterface from '../../../../model/Vacancy';
import CityInterface from '../../../../model/City';
// ui-lib imports
import { DinoButton } from '@uchi/ui-lib-react';
// common components
import MainTabs from '../../../../common/components/Tabs/MainTabs';
import Tabs from '../../../../common/components/Tabs/Tabs';
// images
import RedArrows from './img/red_arrows.svg';
import Team from './img/team.jpg';
// styles
import './Description.css';

interface Props {
  className?: string;
  vacancy: VacancyInterface;
  city: CityInterface;
}

class Description extends React.Component<Props, {selectedTabIndex: number}> {

  private HTML_ID = 'vacancy-details';

  constructor(props: Props) {
    super(props)
    this.state = {
      selectedTabIndex: 0,
    }
    this.onButtonClick = this.onButtonClick.bind(this);
  }

  onButtonClick(ev: React.MouseEvent<HTMLDivElement>): void {
    const id = ev.currentTarget.getAttribute('data-anchor');

    if (id && /^#/.test(id)) {
      const toScroll = document.querySelector(id);
      if (toScroll) {
        toScroll.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  }

  render(): JSX.Element {
    const { city, vacancy } = this.props;
    const { max_experience, min_experience, departament, has_team_success_tab} = vacancy;
    let experience = null;

    if (min_experience && max_experience) {
      let years = 'года';
      if (max_experience > 4) years = 'лет';
      experience = <>{vacancy.min_experience}&ndash;{vacancy.max_experience} {years}</>
    }

    return (
      <div id={this.HTML_ID} className={this.HTML_ID}>
        <div className="container">
        <div className="vacancy-details-inner">
          <div className="vacancy-details-header">
            <h1 className="name bold">{ vacancy.name }</h1>
            <div className="summary">
              <span>{ city.name }</span>
              <span className="experience">{ experience }</span>
              { departament ? <span>{ departament }</span> : null }
            </div>
            <div className="btn-container">
              <DinoButton data-anchor="#vacancy-apply-form" onClick={this.onButtonClick}>Это же я!</DinoButton>
            </div>
          </div>
          <div className="vacancy-details-body">
            <div className="common-description">
              { vacancy.description }
            </div>
            {vacancy.tabs
              ? (
                <Tabs tabs={ vacancy.tabs } hasTeamSuccessTab={ has_team_success_tab }>
                  <div className="team-photo">
                    <img src={Team} alt=""/>
                    <div className="rect rect-1"></div>
                    <div className="rect rect-2"></div>
                    <div className="rect rect-3"></div>
                    <div className="rect rect-4"></div>
                  </div>
                </Tabs>
              )
              : (
                <MainTabs mainTabs={ vacancy.main_tabs }>
                  <div className="team-photo">
                    <img src={Team} alt=""/>
                    <div className="rect rect-1"></div>
                    <div className="rect rect-2"></div>
                    <div className="rect rect-3"></div>
                    <div className="rect rect-4"></div>
                  </div>
                </MainTabs>
              )
            }

          </div>
          <div className="after">
            <img src={RedArrows} alt=""/>
          </div>
        </div>
        </div>
      </div>
    );
  }
}

export default Description;
